import React from 'react'
import { Link } from 'gatsby'
import styled, { css } from 'styled-components'

export const NavItemRow = styled.li`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: baseline;
`

export const NavItemPrefix = styled.span`
  font-family: 'Ubuntu', sans-serif;
  font-weight: 300;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: rgba(var(--text-color), 0.35);
  margin-right: 1.5rem;
  flex-shrink: 0;
  width: 2rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  @media screen and (max-width: 480px) {
    display: none;
  }
`

export const navItemTextStyles = css`
  font-family: 'Merriweather', serif;
  font-weight: 300;
  font-size: clamp(2.5rem, 5vw, 4.5rem);
  line-height: 1.3;
  color: rgb(var(--text-color));
  text-decoration: none;
  display: inline-block;
  transition:
    transform 0.3s ease,
    color 0.3s ease;

  &:visited {
    color: rgb(var(--text-color));
  }

  &.active {
    text-decoration: none;
    text-underline-offset: 0.15em;
    color: rgba(var(--text-color), 0.5);
  }

  &:hover {
    transform: translateX(1rem);
    color: rgba(var(--tltr-awesome-value), 1);
    text-decoration: none;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

const StyledLink = styled(Link)`
  ${navItemTextStyles}
`

const NavLink = ({ to, number, children, onClick, style }) => (
  <NavItemRow style={style}>
    <NavItemPrefix aria-hidden="true">{number}</NavItemPrefix>
    <StyledLink to={to} activeClassName="active" onClick={onClick}>
      {children}
    </StyledLink>
  </NavItemRow>
)

export default NavLink
